// extracted by mini-css-extract-plugin
export default {"feachersSection":"Features_feachersSection__Wi0Li","feacherContainer":"Features_feacherContainer__amMLt"};